import { SEND_PAYMENT_EMAIL } from "queries/neoFact/templates";
import { clientNeoFact } from "@neonumy/api-clients";
import { useMutation } from "@apollo/client";

export default function useSendEmail() {
  const [sendPaymentEmail, { loading: sendPaymentEmailLoading }] = useMutation<
    SendPaymentEmailResponse,
    SendPaymentEmailVars
  >(SEND_PAYMENT_EMAIL, {
    client: clientNeoFact,
    fetchPolicy: "no-cache",
  });

  return {
    sendPaymentEmailLoading,
    sendPaymentEmail,
  };
}
